import { useRouter } from 'next/router';
import * as React from 'react';

import {
  AdminPage,
} from '@/components/AdminPage';
import { AdminTopBarNavMenuFrame } from '@/imports/ui/admin/layouts/AdminTopBarNavMenuFrame';
import { Loading } from '@/imports/ui/chakra/components/Loading';

import { EmployeeRequestOrderPageContent } from '@/modules/employee-request-order/components/EmployeeRequestOrderPageContent';

export const AdminSiteEmployeeRequestOrderPage: React.FC = () => {
  const router = useRouter();
  const employeeRequestOrderId = router.query.employeeRequestOrderId?.toString();

  return (
    <AdminTopBarNavMenuFrame>
      <AdminPage maxWidth="container.lg" marginX="auto">
        {employeeRequestOrderId ? (
          <EmployeeRequestOrderPageContent
            employeeRequestOrderId={employeeRequestOrderId}
            basePath="/admin/employee-requests"
            getBackHref={(organizationId) =>
              `/admin/companies/${organizationId}/details`
            }
          />
        ) : (
          <Loading />
        )}
      </AdminPage>
    </AdminTopBarNavMenuFrame>
  );
};
